export const getECPMessage = (data, locale = "ru") => {
  const normalizedLocale = locale ? locale.split("_")[0] : "ru";
  return JSON.stringify({
    module: "kz.gov.pki.knca.basics",
    method: "sign",
    args: {
      format: "cms",
      data,
      signingParams: {
        decode: false,
        encapsulate: true,
        digested: false,
        tsaProfile: {},
      },
      signerParams: { extKeyUsageOids: [] },
      locale: normalizedLocale,
    },
  });
};
